import * as GrapeSettings from './grape_settings.js';
import * as Permissions from './permission_utils.js';

export function unique_array(data) {
	return data.filter((value, index, self) => {
		return self.indexOf(value) === index;
	});
}

/* DATE FUNCTIONS */
export function get_full_date(date_obj) {
	let days = [
		'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	];
	let months = [
		'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	];
	return days[date_obj.getDay()] + ' ' + date_obj.getDate() + ' ' + months[date_obj.getMonth()] + ' ' + date_obj.getFullYear();
}

export function toJSONDateString(date) {
	if (date === undefined || date === null)
		date = new Date();
	return date.toJSON().slice(0, 10);
}

export function get_time(date_obj) {
	let min = date_obj.getMinutes();
	if (min < 10)
		min = '0' + min;
	return date_obj.getHours() + ':' + min;
}
export function get_timestamp(d) {
	let pad = (n, s=2) => (`${new Array(s).fill(0)}${n}`).slice(-s);
	return `${pad(d.getFullYear(),4)}-${pad(d.getMonth()+1)}-${pad(d.getDate()) }   ${ pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/* LOCAL STORAGE UTILS */
export function get_local_storage_nullable(key, default_value) {
	let val = localStorage.getItem(key);
	if (val === 'null') val = null;
	if (val === null && default_value !== undefined)
		return default_value;
	else
		return val;
}

export async function current_user_id() {
	let res = await Grape.fetches.postJSON('/employee/get_logged_in_employee_id', {});

	if (res.status === 'OK')
		return res.get_logged_in_employee_id.grape_user_id;
	else
		return null;
}

export async function current_user_company_id(employee_id) {
	let res = await Grape.fetches.postJSON('/employee/get_company_id_from_employee_id', { employee_id: employee_id });
	if (res.company_id)
		return res.company_id;
	return null;
}

export function current_employee_id() {
	return get_local_storage_nullable('employee_id');
}

/* UI ELEMENT CONFIGURATION */
export function setCompanyDisplayName()
{
	let use_yooma_logo = Grape.config.public_settings.use_yooma_logo;
	if (use_yooma_logo)
	{ 
		$('.navbar-brand').html('<img src="../../lib/images/yooma-logo.png" style="position: absolute;left: 6px;top: -10px;width: 220px;" >');
		$('.navbar-brand').addClass('hrstaffhub');		
		$('.nav-company-name').addClass('hrstaffhub');
	} 
	let display_company_name = Grape.config.public_settings.display_company_name;
	$('.nav-company-name').html(display_company_name);
}

export async function setCompanyActiveCompanyColour() {
	let res = await Grape.fetches.getJSON('/api/get_setting/public.company_active_scheme');
	var selected_scheme = JSON.parse(res.value);
	if(res.status === 'OK')
		await Grape.fetches.postJSON('/setting/set_color_scheme',{scheme_name: selected_scheme.name});
}

export function setProfileLink()
{
	let id = current_employee_id();
	if (id === null)
		id = -1;

	$('.my_profile_link').find('a').attr('href', '#/employee/view/' + id);
}

// TODO: Unused except by another function.
export async function checkIfSecondWizardDone() {
	let wizard_all_tasks_done = await GrapeSettings.wizard_all_tasks_done();
	if (wizard_all_tasks_done)
		$('.what_to_do_next_icon_badge').hide();
	else
		$('.what_to_do_next_icon_badge').show();
}

/* LOADER UTILS */
export function showLoader() {
	$('#loader').show();
	$('#grape_wrapper').addClass('blurfilter');
}

export function hideLoader() {
	$('#loader').hide();
	$('#grape_wrapper').removeClass('blurfilter');
}
export function addLoaderToPage() {
	if (document.getElementById('loader')) {
		// the loader already exists
	} else {
		const body = document.body;
		const loaderDiv = document.createElement('div');
		loaderDiv.id = 'loader';
  
		const textDiv = document.createElement('div');
		textDiv.className = 'text-center loader-text';
		textDiv.style.top = '35%';
		textDiv.style.left = '0';
		textDiv.style.position = 'relative';
		textDiv.style.zIndex = '5005';
  
		const icon = document.createElement('i');
		icon.style.fontSize = '9em';
		icon.style.display = 'flex';
		icon.style.justifyContent = 'center';
		icon.className = 'fa-duotone fa-loader fa-spin';
  
		textDiv.appendChild(icon);
		loaderDiv.appendChild(textDiv);
		body.appendChild(loaderDiv);
	}
  
	const footerDiv = document.createElement('div');
	footerDiv.id = 'footer';
  
	const floatRightDiv = document.createElement('div');
	floatRightDiv.className = 'float-right';
	floatRightDiv.style.position = 'relative';
  
	const img = document.createElement('img');
	img.id = 'grape-footer-signature';
  
	floatRightDiv.appendChild(img);
	footerDiv.appendChild(floatRightDiv);
  
	document.body.appendChild(footerDiv); // Append footerDiv to document.body
}

/* Shared Data */
export async function getGrapeListAccessRoles() {
	let res = await Grape.fetches.getJSON('/settings/get_users_access_roles', {});
	if (res)
		return res.records || []; // Null safety
	else
		return [];
}

/* SECURITY FUNCTIONS */
// Since this function can be called multiple times, we are going to create a sort of buffer for it
// We will wait a second ... and see if this was called again - if so reset the second -- when nothing happens for a full second proceed and call it
//added force refresh to make sure the cache is up to date
export async function refresh_data_visible_roles(force_refresh = false)
{
	// Call the existing update_visible_roles function
	Grape.update_visible_roles();

	// Immediately hide all elements with data-visible-feature
	$('section#container, .ps-dialog, .ps-navbar').find('[data-visible-feature]').each(function () {
		$(this).hide();
	});

	// If there is a current session
	if (window.Grape.currentSession)
	{
		let features;
		try
		{
			if (force_refresh)
				await Grape.cache.refresh('FeatureRolesLookup');
			
			features = await Grape.cache.get('FeatureRolesLookup');
		} catch (e) {
			features = [];
			console.error('Error fetching user features:', e);
		}

		// Create a map of features for quick lookup
		let feature_map = new Map(features.map(f => [f.feature, f.has_access]));

		// After fetching the access data, reveal elements based on user features
		$('section#container, .ps-dialog, .ps-navbar').find('[data-visible-feature]').each(function ()
		{
			let required_features = $(this).attr('data-visible-feature').split(' ');
			let should_show = required_features.some(feature => feature_map.get(feature) === true);

			// Show element if the user has the required feature access
			if (should_show)
				$(this).show();
			else
				$(this).hide();
		});
	} else {
		// If no session exists, check if the URL is an anonymous survey URL
		let is_anonymous_survey_url = document.URL.includes('/#/surveys/anonymous_survey/');

		// If the current URL is not an anonymous survey URL, redirect to the login page
		if (!is_anonymous_survey_url && !document.URL.includes("grape-ui/new_password")) {
			Grape.navigate('/grape-ui/log-in');
		}
	}
}

export async function redirectOnAccessDenied(featureName) {
	const features = featureName.split(' ');
	// now check if any of these has access
	for (let a = 0; a < features.length; a++)
	{
		let v = await Permissions.checkAccessRights(features[a]);
		if (v === false)
		{
			Grape.navigate('#/access_denied/');
			return true;
		}
	}
	return false;
}

/* TRANSLATOR FUNCTIONS */
export function get_translator(context) {
	let translator = window.translator.context(context);
	return translator.translate.bind(translator);
}

export function wrap_api_result(res, tr, success_call)
{
	if (res.status === 'OK')
	{
		if (success_call instanceof Function)
			success_call();
	}
	else if (res.status === 'ERROR')
		Grape.alerts.alert({ type: 'error', message: res.message, title: tr('Error', 'Error') });
	else if (res.error)
		Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
	else
		Grape.alerts.alert({type: 'error', title: tr('Error', 'Error'), message: tr('Something went wrong...', 'Something went wrong...')});
}

export function parseEmployeeHolidayDates(res) {
	let employeeEventDates = []; // reset
	if (!res) res = []; // In cases where no holidays are loaded
	for (let a = 0; a < res.length; a++)
	{
		employeeEventDates[getDate(res[a].holiday_date)] = { 'date': new Date(res[a].holiday_date), 'name': res[a].description, 'css_class': res[a].css_class_name, 'holiday_type': res[a].holiday_type, 'type': 'holiday' };
	}
	return employeeEventDates;
}

/* VALIDATION FUNCTION */
export function validate_id(id_number) {
	function checkSum(id) {
		let sum = 0;
		for (let i = 0; i < 13; i++)
		{
			if (i % 2 == 0)
				sum += parseInt(id.charAt(i));
			else
			{
				let add = parseInt(id.charAt(i)) * 2;
				sum += (add - 1) % 9 + 1;
			}
		}

		if (sum % 10 == 0)
			return true;
		else
			return false;
	}

	let valid = true;
	let msg = '';
	let save = true;
	if (!id_number)
	{
		msg = 'ID number can not be empty. ';
		valid = false;
		save = false;
	} else if (id_number.length != 13)
	{
		msg = 'A South African ID number is 13 digits long. ';
		valid = false;
	}
	else if (id_number.match(/^[0-9]+$/) == null)
	{
		msg = 'A South African ID number contains only digits. ';
		valid = false;
	}
	else if (!checkSum(id_number))
	{
		msg = 'This ID number is not a valid South African ID number. ';
		valid = false;
	}
	return { 'valid': valid, 'message': msg, 'save': save };
}

export async function set_language_phrases()
{
	if (window.Grape.currentSession)
	{
		let res = await Grape.fetches.postJSON('/general/get_language_phrases', {});
		window.global_language_phrases = {};

		// save the words in a key-value pair
		if (res != null)
		{
			for (let a = 0; a < res.length; a++)
				window.global_language_phrases[res[a].token] = res[a].phrase;
		};

		window.language_loaded = true

		// Store language phrases in localStorage
		localStorage.setItem('language_phrases', JSON.stringify(window.global_language_phrases));
	}
}

export async function set_username()
{
	if (window.Grape.currentSession)
	{
		if (window.Grape.currentSession.user.username)
		{
			$('#username_login').html(window.Grape.currentSession.user.username);
			localStorage.setItem('username', window.Grape.currentSession.user.username); 
		}
	}
}

/* TABLE TO CSV UTIL */
export function table_to_csv(table)
{
	if (table === null || table.rows.length === 0 || table === undefined)
	{
		Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'No data to download!'});
		return;
	}

	let csv_string = '';
	for (let row of table.rows)
	{
		let row_data = [];
		for (let cell of row.cells)
		{
			// Trim the cell's text content to remove excess whitespace and line breaks
			let cell_text = cell.textContent.replace(/\s+/g, ' ').trim();
			row_data.push(cell_text);
		}
		csv_string += row_data.join(',') + '\r\n';
	}

	return csv_string;
}
